import React, { useEffect, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import { alert_icon } from '../../../assets/images'

const Tabbar = ({ list, total, classes = '', loading = false, ids = [], newPageId = '', alertIcon = '', tabItemClassName, changeHandler = () => {} }) => {
  const [activeId, setActiveId] = useState(newPageId)
  list = list ? list : new Array(4).fill({})
  const main_total = total || Array(list.length).fill(0)
  total = total ? total.map((val) => (`(${val})`)) : new Array(list?.length ?? 4).fill('')

  useEffect(() => {
    setActiveId(newPageId)
  }, [newPageId])

  const handler = (id) => {
    setActiveId(id)
    changeHandler(id)
  }

  return (
    <div className={classes}>
      <div className='relative border-b border-gray-300'>
        <nav className='-mb-px flex w-full justify-start overflow-x-auto' aria-label='Tabs'>
          {list.map((item, index) => {
            if (item === 'Partially Completed' && (main_total[index] || 0) <= 0) {
              return null
            }
            const id = ids.length > index ? ids[index] : item
            const isActive = `${activeId}` === `${id}`
            return (
              <span
                key={item || index}
                onClick={(e) => handler(e.currentTarget.id)}
                id={id}
                className={`flex flex-row border-b-2 px-5 py-3 text-center text-ts-sm transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                  isActive
                    ? 'border-ds-brand text-ds-brand font-semibold'
                    : 'border-transparent text-gray-600 font-medium hover:text-gray-900'
                } ${tabItemClassName || ''}`}
              >
                {item === alertIcon && parseInt(total[index]?.replace(/[()]/g, '')) > 0 ? <img src={alert_icon} className='pr-1.5 pointer-events-none' height={22} width={22} /> : ''}
                {loading ? <Skeleton width={100} height={25} /> : `${item} ${total[index]}`}
              </span>
            )
          })}
        </nav>
      </div>
    </div>
  )
}

export default Tabbar
